import React, { ChangeEvent, useEffect, KeyboardEvent, useRef, useState, forwardRef } from 'react';
import { Icon } from './Icon';
import './Input.css'

export interface InputProps {
  value?: string;
  placeholder?: string;
  onChange?: (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onKeyDown?: (event: KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  ariaLabel?: string;
  id?: string;
  name?: string;
  type?: string;
  [x: string]: any;
  // svgPath?: string;
  // leadingIconName?: string;
  // trailingIconName?: string;
  // leadingIconColor?: string;
  // trailingIconColor?: string;
  align?: 'left' | 'center' | 'right';
  multiLine?: boolean;
  numberOfLines?: number;
  maxNumberOfLines?: number;
  className?: string; // Add className prop
}

const Input = forwardRef<HTMLInputElement | HTMLTextAreaElement, InputProps>(({
  value,
  placeholder,
  onChange,
  onKeyDown,
  ariaLabel,
  id,
  name,
  // leadingIconName,
  // trailingIconName,
  // leadingIconColor,
  // trailingIconColor,
  numberOfLines = 1,
  maxNumberOfLines = 4,
  multiLine = false,
  type = 'text',
  className,
  align = 'left',
  ...props
}, ref) => {
  const inputRef = useRef<HTMLInputElement | HTMLTextAreaElement>(null);

  useEffect(() => {
    if (ref) {
      (ref as React.MutableRefObject<HTMLInputElement | HTMLTextAreaElement | null>).current = inputRef.current;
    }
  }, [ref]);

  const [textareaValue, setTextareaValue] = useState(value || '');

  const handleTextareaChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    setTextareaValue(event.target.value);
    if (onChange) onChange(event);
  };

  useEffect(() => {
    if (value !== undefined) {
      setTextareaValue(value);
    }
  }, [value]);

  useEffect(() => {
    if (multiLine && inputRef.current) {
      const textarea = inputRef.current as HTMLTextAreaElement;
      textarea.style.height = 'auto';
      const lineHeight = parseFloat(getComputedStyle(textarea).getPropertyValue('--size-base')) || 24;
      const maxHeight = (maxNumberOfLines) * lineHeight;
      textarea.style.height = `${Math.min(textarea.scrollHeight, maxHeight)}px`;
    }
  }, [textareaValue, multiLine, maxNumberOfLines]);

  const focusInput = () => {
    if (multiLine) {
      if (inputRef.current) {
        const textarea = inputRef.current as HTMLTextAreaElement;
        textarea.focus();
      }
    } else {
      if (inputRef.current) {
        const input = inputRef.current as HTMLInputElement;
        input.focus();
      }
    }
  };

  return (
    <div className={`${!multiLine ? 'input' : 'input'}-wrapper width-fill ${className || ''}`} onClick={focusInput}>
      {/* {leadingIconName && ( */}
      {/*   <Icon */}
      {/*     svgPath={svgPath} */}
      {/*     name={leadingIconName} */}
      {/*     color={leadingIconColor} */}
      {/*   /> */}
      {/* )} */}
      {multiLine ? (
        <textarea
          ref={inputRef as React.RefObject<HTMLTextAreaElement>}
          className={`textarea ${className || ''} ${align}`}
          value={textareaValue}
          placeholder={placeholder}
          onChange={handleTextareaChange}
          onKeyDown={onKeyDown as (event: React.KeyboardEvent<HTMLTextAreaElement>) => void}
          aria-label={ariaLabel || placeholder}
          id={id}
          name={name}
          rows={numberOfLines}
          style={{
            maxHeight: `calc(var(--size-base) * ${maxNumberOfLines})`,
          }}
          {...props}
        />
      ) : (
        <input
          ref={inputRef as React.RefObject<HTMLInputElement>}
          className={`input ${className || ''} ${align}`}
          type={type}
          value={value}
          placeholder={placeholder}
          onChange={onChange}
          onKeyDown={onKeyDown as (event: React.KeyboardEvent<HTMLInputElement>) => void}
          aria-label={ariaLabel || placeholder}
          id={id}
          name={name}
          {...props}
        />
      )}
      {/* {trailingIconName && ( */}
      {/*   <Icon */}
      {/*     svgPath={svgPath} */}
      {/*     name={trailingIconName} */}
      {/*     color={trailingIconColor} */}
      {/*   /> */}
      {/* )} */}
    </div>
  );
});

Input.displayName = 'Input';
export { Input };

